import queryString from 'query-string'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'
import { post, put, requestHeader, handleError } from './api-routes.common'

const baseURL = env.SERVER_ADDR

export const downLoadDispatches = (url: string, endpoint: any) => {
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )
  const downloadLink = document.createElement('a')
  downloadLink.href = `${baseURL}api/v2/export/${url}${token}/${endpoint}${''}`
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}
export const getDashboard = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/order/returns/dashboard`,
  }).pipe(catchError(handleError('getDashboard')))

export const getReturnOrders = ({ page, search, type }) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/order/returns?page_no=${page}&query=${search}&type=${type}`,
  }).pipe(catchError(handleError('getReturnOrders')))

export const getReturnBatches = ({
  page,
  search,
  type,
  end_date,
  start_date,
}) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/returns/batches?page_no=${page}&query=${search}&type=${type}&start_date=${start_date}&end_date=${end_date}`,
  }).pipe(catchError(handleError('getReturnBatches')))

export const getPackingDetails = (order_id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/dispatch/orders/${order_id}/packing`,
  }).pipe(catchError(handleError('getPackingDetails')))

export const getReturnBatchDetails = (batch_id: number) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/returns/batches/${batch_id}`,
  }).pipe(catchError(handleError('getReturnBatchDetails')))

export const updateCustomerAddress = (order_id, customer_id, data) =>
  put(`/order/${order_id}/customer/${customer_id}`, data)

export const updateReturnAction = (data: { action_type: string }, action) =>
  put(`/order/returns/${action}`, data)

export const createComplaint = (complaint: any) => post('/support', complaint)

export const getOrderComplaint = (order_id: number) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/complaints`,
  }).pipe(catchError(handleError('getOrderComplaint')))

export const addNote = (complaint_id: number, note: { note: any }) =>
  post(`/support/${complaint_id}/note`, note)

export const addNotes = (order_id, data) =>
  post(`/orders/${order_id}/notes`, data)

export const getAllComplaints = (filters) => {
  if (filters.status === 'any') delete filters.status
  if (filters.type === 'any') delete filters.type
  const stringified = queryString.stringify(filters)
  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/support?${stringified}`,
  }).pipe(catchError(handleError('getAllComplaints')))
}

export const getComplaintDetails = (complaint_id: number) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/support/${complaint_id}`,
  }).pipe(catchError(handleError('getComplaintDetails')))

export const updateComplaint = (complaint_id: number) =>
  put(`/support/${complaint_id}`, {})

export const reOpenComplaint = (complaint_id: number) =>
  put(`/support/${complaint_id}/reopen`, {})

export const getInventoryRequests = (filters) => {
  // if (filters.status === 'any') delete filters.status;
  // if (filters.type === 'any') delete filters.type;
  const stringified = queryString.stringify(filters)
  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/inventory/requests?${stringified}`,
  }).pipe(catchError(handleError('getInventoryRequests')))
}
export const getInventoryRequestsDetails = (id) => {
  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/inventory/requests/${id}`,
  }).pipe(catchError(handleError('getInventoryRequestsDetails')))
}
export const getPrintLink = (link, id) => {
  const { token } = JSON.parse(localStorage.getItem('user_info') || '{}')
  return `${baseURL}api/v2/print/returns/restock/${token}/${id}`
}

export const getOrderMeta = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/meta`,
  }).pipe(catchError(handleError('getOrderMeta')))

export const addAComment = (support_id, note) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/support/${support_id}/note`,
    body: note,
  }).pipe(catchError(handleError('addAComment')))

export const updateTags = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/tag`,
    body: data,
  }).pipe(catchError(handleError('updateTags')))

export const markReadyToShip = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/ready-to-ship`,
    body: data,
  }).pipe(catchError(handleError('markReadyToShip')))

export const updateAddress = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/address`,
    body: data,
  }).pipe(catchError(handleError('updateAddress')))

export const createConsignment = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/consignment`,
    body: data,
  }).pipe(catchError(handleError('createConsignment')))

export const cancelConsignment = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/consignment`,
    body: data,
  }).pipe(catchError(handleError('cancelConsignment')))

export const generateMoneyOrderLabels = (
  data,
  options = JSON.parse(
    '{"responseType": "arraybuffer", "observe": "response"}',
  ),
) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/bulk/money-order-labels`,
    body: data,
    ...options,
  }).pipe(catchError(handleError('generateMoneyOrderLabels')))

export const printInvoicesDarazFromDispatch = (
  dispatch_id,
  options = JSON.parse('{"responseType": "string", "observe": "response"}'),
) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/dispatch/${dispatch_id}/invoices/daraz`,
    ...options,
  }).pipe(catchError(handleError('printInvoicesDarazFromDispatch')))

export const printShippingLabels = (
  data,
  options = JSON.parse(
    '{"responseType": "arraybuffer", "observe": "response"}',
  ),
) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/print/order/labels`,
    body: data,
    ...options,
  }).pipe(catchError(handleError('printShippingLabels')))

export const createNote = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/notes`,
    body: data,
  }).pipe(catchError(handleError('createNote')))

export const sendSMS = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/send-sms`,
    body: data,
  }).pipe(catchError(handleError('sendSMS')))

export const createOrderConsignment = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/consignments`,
    body: data,
  }).pipe(catchError(handleError('createOrderConsignment')))

export const deleteProduct = (order_id, product_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/products/${product_id}`,
  }).pipe(catchError(handleError('deleteProduct')))

export const updateProductsQuantity = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/products`,
    body: data,
  }).pipe(catchError(handleError('updateProductsQuantity')))

export const updateCustomerNoteOnPrint = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/note-print`,
    body: data,
  }).pipe(catchError(handleError('updateCustomerNoteOnPrint')))

export const addShippingLine = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/shipping`,
    body: data,
  }).pipe(catchError(handleError('addShippingLine')))

export const addDiscountLine = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/discounts`,
    body: data,
  }).pipe(catchError(handleError('addDiscountLine')))

export const addPaymentLine = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/payments`,
    body: data,
  }).pipe(catchError(handleError('addPaymentLine')))

export const deleteShippingLine = (order_id, shipping_line_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/shipping/${shipping_line_id}`,
  }).pipe(catchError(handleError('deleteShippingLine')))

export const deleteDiscountLine = (order_id, discount_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/discounts/${discount_id}`,
  }).pipe(catchError(handleError('deleteDiscountLine')))

export const deletePayment = (order_id, payment_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/payments/${payment_id}`,
  }).pipe(catchError(handleError('deletePayment')))

export const addNewComplaint = (data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/support`,
    body: data,
  }).pipe(catchError(handleError('addNewComplaint')))

export const assignNewTag = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/tags`,
    body: data,
  }).pipe(catchError(handleError('assignNewTag')))

export const getOrderHistory = (order_id, customer_id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/customer/${customer_id}/history`,
  }).pipe(catchError(handleError('getOrderHistory')))

export const updateAdditionalInfo = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/order/${order_id}/meta`,
    body: data,
  }).pipe(catchError(handleError('updateAdditionalInfo')))

export const deleteConsignment = (order_id, tracking_id, force) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/consignments/${tracking_id}?force=${force}`,
  }).pipe(catchError(handleError('deleteConsignment')))

export const getComplaints = (order_id: string) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/complaints`,
  }).pipe(catchError(handleError('getComplaints')))

export const addNewTag = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/tags`,
    body: data,
  }).pipe(catchError(handleError('addNewTag')))

export const getDuplicateOrders = (order_id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/order/${order_id}/duplicates`,
  }).pipe(catchError(handleError('getDuplicateOrders')))

export const mergeDuplicateOrders = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/order/${order_id}/merge`,
    body: data,
  }).pipe(catchError(handleError('mergeDuplicateOrders')))

export const uploadDispatch = (data, dispatchID) => {
  const formData = new FormData()
  formData.append('attachment', data.attachment, data.attachment.name)
  return ajax({
    headers: {},
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/courier/dispatch/${dispatchID}/attach`,
    body: formData,
  }).pipe(catchError(handleError('uploadDispatch')))
}

export const splitThisOrder = (order_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/order/${order_id}/split`,
    body: data,
  }).pipe(catchError(handleError('splitThisOrder')))

export const uploadOrderNoteAttachment = (orderId, file, comment) => {
  const formData = new FormData()
  formData.append('attachment', file)
  formData.append('comment', comment)

  // Get headers without Content-Type for FormData
  const { 'Content-Type': _, ...headers } = requestHeader()

  return ajax({
    headers,
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${orderId}/notes/attachment`,
    body: formData,
  }).pipe(catchError(handleError('uploadOrderNoteAttachment')))
}
